



























































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import { centros } from "@/shared/dtos/centros";
import centrosModule from "@/store/modules/centros-module";
import { UtilsString } from "@/utils/utils-string";

declare global {
  interface Window {
    google: any;
  }
}

interface GoogleMapMarker {
  position: {
    lat: number;
    lng: number;
  };
  info: any;
  nombre: string;
  id: number;
  direccion?: string;
  colorRuta?: string;
  type?: "start" | "end" | "center";
}

interface PuntoRuta {
  nombre: string;
  direccion?: string;
  posicion: string;
  type: "start" | "center" | "end";
  distanciaAlSiguiente?: number;
  tiempoAlSiguiente?: number;
  lat: number;
  lng: number;
  id_centro: number;
  siguiente?: PuntoRuta; // Nuevo campo para el siguiente centro
  colorRuta?: string; // Color de la ruta
}

interface DayPlan {
  day: string;
  centers: PuntoRuta[];
  expanded: boolean;
  travelTimeToFirstCenter?: number;
  distanciaAlPrimerCentro?: number;
  tiempoTotalDia?: number; // tiempo total del día en minutos
  hotel?: {
    name: string;
    address: string;
    price: number;
    mapUrl: string;
  };
}

interface Hotel {
  name: string;
  address: string;
  price: number;
  mapUrl: string;
}

@Component({
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxSearchPanel,
  },
})
export default class PlanificadorRutasCompleto extends Vue {
  // Configuración del mapa
  public center = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;
  public valid = false;
  public loading = false;

  // Configuración de ruta
  public startLocation: { lat: number; lng: number } | null = null;
  public endLocation: { lat: number; lng: number } | null = null;
  public startLocationName = "";
  public endLocationName = "";
  public customMarkers: GoogleMapMarker[] = [];
  public selectedCentros: number[] = [];
  public selectedCentros_DropDown: any[] = [];
  public usar_ruta_optimizada = false;
  public maxHorasPorDia: number = 8; // máximo de horas al día
  public tiempoLimpiezaCentro: number = 2.5; // en horas (media hora por defecto)
  public diasMaximosFuera: number = 5; // días máximos fuera de la ruta

  // Configuración de días
  public weekDays = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  public workingDays: string[] = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
  ];

  public rutaColors: string[] = [
    "#1e88e5", // Azul
    "#43a047", // Verde
    "#ff9900", // Naranja
    "#8e24aa", // Violeta
    "#fb8c00", // Ámbar
    "#3949ab", // Azul intenso
    "#d81b60", // Rosa fuerte
  ];

  public maxCentersPerDay = 3;
  public maxSelectedCenters = 30;

  // Configuración de vehículo
  public consumoGasolina = 7;
  public precioGasolina = 1.5;

  // Resultados
  public rutaCalculada = false;
  //public routePlan: DayPlan[] = [];

  public routePlans: DayPlan[][] = [];

  // Ventana de información
  public infoWindowOpened = false;
  public infoWindowOptions = { pixelOffset: { width: 0, height: -30 } };
  public infoWindowPosition: { lat: number; lng: number } | null = null;
  public infoWindowContent: { nombre?: string; direccion?: string } = {};
  public timeoutCerrarInfo: ReturnType<typeof setTimeout> | null = null;
  // Notificaciones
  public snackbar = {
    show: false,
    text: "",
    color: "success",
  };

  // Reglas de validación
  public requiredRules = [(v: string) => !!v || "Este campo es obligatorio"];
  public positiveNumberRules = [(v: number) => v > 0 || "Debe ser positivo"];
  public workingDaysRules = [
    (v: string[]) => v.length > 0 || "Seleccione al menos un día",
  ];

  async created() {
    await centrosModule.getcentroses();
  }

  // Propiedades computadas
  get centrosOptions() {
    return centrosModule.centroses;
  }

  get filteredCentrosOptions() {
    return this.centrosOptions.filter(
      (center) =>
        !this.selectedCentros.includes(center.id) ||
        this.selectedCentros_DropDown.some(
          (selected: any) => selected.id === center.id
        )
    );
  }

  get markers(): GoogleMapMarker[] {
    return this.centrosOptions.map((x: centros) => ({
      position: {
        lat: Number.parseFloat(x.latitud.replace(",", ".")),
        lng: Number.parseFloat(x.longitud.replace(",", ".")),
      },
      info: x.toJson(),
      nombre: x.nombre,
      direccion: x.direccion,
      id: x.id,
      type: "center",
    }));
  }

  /*get filteredMarkers(): GoogleMapMarker[] {
    let result: GoogleMapMarker[] = this.markers.filter((marker) =>
      this.selectedCentros.includes(marker.id)
    );
    return [...result, ...this.customMarkers];
  }*/
  get filteredMarkers(): GoogleMapMarker[] {
    const marcadores: GoogleMapMarker[] = [];

    for (const plan of this.routePlans) {
      for (const day of plan) {
        for (const punto of day.centers) {
          // Buscar el marcador original asociado
          const baseMarker = this.markers.find((m) => m.id === punto.id_centro);
          if (baseMarker) {
            marcadores.push({
              ...baseMarker,
              type: punto.type,
              colorRuta: punto.colorRuta,
            });
          }
        }
      }
    }

    // Incluir también los personalizados (inicio y fin)
    return [...marcadores, ...this.customMarkers];
  }

  get costoGasolina() {
    return (
      (this.distanciaTotal / 1000) *
      (this.consumoGasolina / 100) *
      this.precioGasolina
    );
  }
  get distanciaTotal(): number {
    return this.routePlans
      .flatMap((route) => route) // Flatten cada routePlan
      .flatMap((day) => day.centers)
      .reduce((total, center) => total + (center.distanciaAlSiguiente || 0), 0);
  }

  get tiempoTotal(): number {
    return this.routePlans
      .flatMap((route) => route)
      .flatMap((day) => day.centers)
      .reduce((total, center) => total + (center.tiempoAlSiguiente || 0), 0);
  }

  get tiempoLimpiezaTotal(): number {
    const totalCentros = this.routePlans
      .flatMap((route) => route)
      .flatMap((day) => day.centers).length;
    return totalCentros * this.tiempoLimpiezaCentro * 3600; // en segundos
  }

  get tiempoTotalCombinado(): number {
    return this.tiempoTotal + this.tiempoLimpiezaTotal;
  }
  // Resumen para múltiples DayPlan
  getResumenRuta(planDia: DayPlan | DayPlan[]) {
    const planes = Array.isArray(planDia) ? planDia : [planDia];

    let limpieza = 0;
    let conduccion = 0;
    let distancia = 0;

    for (const d of planes) {
      const resumen = this.getResumenRutaDeUnDia(d);
      limpieza += resumen.limpieza;
      conduccion += resumen.conduccion;
      distancia += resumen.distancia;
    }

    const gasolina =
      (distancia / 1000) * (this.consumoGasolina / 100) * this.precioGasolina;

    return {
      limpieza,
      conduccion,
      total: limpieza + conduccion,
      distancia,
      gasolina,
    };
  }

  // Resumen para un solo DayPlan
  getResumenRutaDeUnDia(d: DayPlan) {
    const limpieza =
      d.centers.filter((c) => c.type === "center").length *
      this.tiempoLimpiezaCentro *
      3600;

    const conduccion =
      d.centers.reduce((sum, c) => sum + (c.tiempoAlSiguiente || 0), 0) +
      (d.travelTimeToFirstCenter || 0);

    const distancia =
      d.centers.reduce((sum, c) => sum + (c.distanciaAlSiguiente || 0), 0) +
      (d.distanciaAlPrimerCentro || 0);

    const gasolina =
      (distancia / 1000) * (this.consumoGasolina / 100) * this.precioGasolina;

    return {
      limpieza,
      conduccion,
      total: limpieza + conduccion,
      distancia,
      gasolina,
    };
  }

  // Métodos
  setStartLocation(place: any) {
    if (!place || !place.geometry) return;
    this.startLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    this.startLocationName = place.name || place.formatted_address;
    this.updateCustomMarker(
      "start",
      this.startLocation,
      this.startLocationName
    );
    this.center = this.startLocation;
    this.zoom = 12;
  }

  setEndLocation(place: any) {
    if (!place || !place.geometry) return;
    this.endLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    this.endLocationName = place.name || place.formatted_address;
    this.updateCustomMarker("end", this.endLocation, this.endLocationName);
  }

  updateCustomMarker(
    type: "start" | "end",
    position: { lat: number; lng: number },
    nombre: string
  ) {
    this.customMarkers = this.customMarkers.filter((m) => m.type !== type);
    this.customMarkers.push({
      position,
      info: {},
      nombre,
      id: type === "start" ? -1 : -2,
      type,
    });
  }

  updateSelectedCentros(e: any) {
    this.selectedCentros = e.value || [];
  }

  selectionChanged(e: any) {
    this.selectedCentros_DropDown = e.selectedRowKeys;
    this.selectedCentros = e.selectedRowKeys.map((item: any) => item.id);
  }

  getDisplayText() {
    if (!this.selectedCentros.length) return "Seleccione centros";
    const selected = this.centrosOptions.filter((c) =>
      this.selectedCentros.includes(c.id)
    );
    return selected.map((c) => c.nombre).join(", ");
  }

  formatDistance(metros: number = 0): string {
    return metros < 1000 ? `${metros} m` : `${(metros / 1000).toFixed(1)} km`;
  }

  formatTime(segundos: number = 0): string {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    return horas > 0 ? `${horas}h ${minutos}min` : `${minutos} min`;
  }

  customMarker(type?: "start" | "end" | "center" | "hotel", color?: string) {
    let finalColor = color || "#4285F4"; // Default para centros
    const texto = UtilsString.ValueOf(color); // "1", "2", ...
    const color_fijo = "ff330000"; // azul fijo o cualquier otro que prefieras
    // Forzar color por tipo
    if (type === "start") {
      finalColor = "#43a047"; // Verde
      return {
        url: `http://maps.google.com/mapfiles/ms/icons/${this.hexToGoogleColor(
          finalColor
        )}-dot.png`,
        scaledSize: { width: 50, height: 50 },
      };
    } else if (type === "end") {
      finalColor = "#ff9900"; // Naranja
      return {
        url: `http://maps.google.com/mapfiles/ms/icons/${this.hexToGoogleColor(
          finalColor
        )}-dot.png`,
        scaledSize: { width: 50, height: 50 },
      };
    } else if (type === "hotel") {
      return {
        url: "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/lodging-71.png",
        scaledSize: { width: 40, height: 40 },
      };
    }

    return {
      url: `https://mt.google.com/vt/icon?text=${texto}&psize=16&font=fonts/arialuni_t.ttf&color=${color_fijo}&name=icons/spotlight/spotlight-waypoint-b.png&ax=50&ay=50&scale=1`,
      scaledSize: { width: 50, height: 50 },
    };
  }

  hexToGoogleColor(hex: string): string {
    const mapa = {
      "#1e88e5": "blue",
      "#43a047": "green",
      "#ff9900": "orange",
      "#8e24aa": "purple",
      "#fb8c00": "yellow",
      "#3949ab": "blue",
      "#d81b60": "pink",
    };
    return mapa[hex.toLowerCase() as keyof typeof mapa] || "red";
  }

  openInfoWindow(index: number) {
    const marker = this.filteredMarkers[index];
    if (marker) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = {
        nombre: marker.nombre,
        direccion: marker.direccion,
      };
      this.infoWindowOpened = true;
    }
  }

  closeInfoWindow() {
    // this.infoWindowOpened = false;
    if (this.timeoutCerrarInfo) clearTimeout(this.timeoutCerrarInfo);

    this.timeoutCerrarInfo = setTimeout(() => {
      this.infoWindowOpened = false;
      this.timeoutCerrarInfo = null;
    }, 1500); // 1.5 segundos de retardo
  }

  toggleDayExpansion(planIndex: number, dayIndex: number) {
    const plan = this.routePlans[planIndex];
    if (plan && plan[dayIndex]) {
      plan[dayIndex].expanded = !plan[dayIndex].expanded;
    } else {
      console.warn("Índice de ruta o día inválido:", planIndex, dayIndex);
    }
  }

  async calcularRuta() {
    try {
      this.loading = true;
      this.rutaCalculada = false;
      this.routePlans = []; // Reiniciar las rutas planificadas

      // Validaciones básicas
      if (!this.startLocation) throw new Error("Seleccione un punto de inicio");
      if (!this.endLocation) throw new Error("Seleccione un punto final");
      if (!this.workingDays.length)
        throw new Error("Seleccione días laborables");
      if (!this.selectedCentros.length)
        throw new Error("Seleccione al menos un centro");

      const request = {
        startLocation: this.startLocation,
        endLocation: this.endLocation,
        startLocationName: this.startLocationName,
        endLocationName: this.endLocationName,
        selectedCentros: this.selectedCentros,
        maxCentersPerDay: this.maxCentersPerDay,
        workingDays: this.workingDays,
        usarRutaOptimizada: this.usar_ruta_optimizada,
        maxHorasPorDia: this.maxHorasPorDia,
        tiempoLimpiezaCentro: this.tiempoLimpiezaCentro,
        diasMaximosFuera: this.diasMaximosFuera,
        consumoGasolina: this.consumoGasolina,
        precioGasolina: this.precioGasolina,
      };

      centrosModule
        .enviar_ruta(request)
        .then((response: any) => {
          if (response.error) {
            throw new Error(response.error);
          }
          const data = response;

          // Asignar rutas planificadas por semanas
          this.routePlans = data.Planes.map((ruta: any[], index: number) =>
            ruta.map((dia: any) => {
              const colorRuta = this.rutaColors[index % this.rutaColors.length];
              return {
                day: dia.Dia,
                tiempoTotalDia: dia.TiempoTotalDia,
                Hotel: dia.Hotel,
                centers: dia.Centros.map((centro: any) => ({
                  nombre: centro.Nombre,
                  direccion: centro.Direccion,
                  lat: centro.Lat,
                  lng: centro.Lng,
                  posicion: {
                    lat: centro.Lat,
                    lng: centro.Lng,
                  },
                  id_centro: centro.IdCentro,
                  distanciaAlSiguiente: centro.DistanciaAlSiguiente,
                  tiempoAlSiguiente: centro.TiempoAlSiguiente,
                  type: centro.Tipo,
                  siguiente: centro.Siguiente || null,
                  colorRuta: index + 1, //colorRuta || null,
                })),
                rutaTiempos: {
                  distanciaTotal: dia.rutaTiempos.DistanciaTotal,
                  tiempoTotal: dia.rutaTiempos.TiempoTotal,
                  tiempoLimpiezaTotal: dia.rutaTiempos.TiempoLimpiezaTotal,
                  costoGasolina: dia.rutaTiempos.CostoGasolina,
                },
                expanded: false, // estado inicial en Vue
              };
            })
          );

          this.rutaCalculada = true;
          this.snackbar = {
            show: true,
            text: "Ruta calculada correctamente",
            color: "success",
          };
        })
        .catch((error: any) => {
          console.error("Error al calcular la ruta:", error);
          this.snackbar = {
            show: true,
            text: error.message || "Error inesperado al calcular la ruta",
            color: "error",
          };
        })
        .finally(() => {
          this.loading = false;
        });
    } catch (error) {
      console.error("Error al calcular ruta:", error);
      //@ts-ignore
      this.snackbar = { show: true, text: error.message, color: "error" };
    } finally {
      this.loading = false;
    }
  }

  abrirGoogleMaps(pos: { lat: number; lng: number }) {
    const url = `https://www.google.com/maps?q=${pos.lat},${pos.lng}`;
    window.open(url, "_blank");
  }

  GuardarRuta() {
    // Implementar la lógica para guardar la ruta
    const planesParaGuardar = this.routePlans.map(
      (semana: DayPlan[], indexSemana: number) => {
        return semana.map((dia: DayPlan) => {
          return {
            Dia: dia.day,
            TiempoTotalDia: dia.tiempoTotalDia,
            Hotel: dia.hotel,
            Centros: dia.centers.map((centro: any) => {
              return {
                Nombre: centro.nombre,
                Direccion: centro.direccion,
                Lat: centro.lat,
                Lng: centro.lng,
                IdCentro: centro.id_centro,
                DistanciaAlSiguiente: centro.distanciaAlSiguiente,
                TiempoAlSiguiente: centro.tiempoAlSiguiente,
                Tipo: centro.type,
                Siguiente: centro.siguiente || null,
              };
            }),
          };
        });
      }
    );

    centrosModule
      .GuardarRuta({
        RutaCalculada: this.rutaCalculada,
        rutaTiempos: null,
        Planes: planesParaGuardar,
        planificacion: {
          nombre: this.planificacion_nombre,
          id: 0,
        },
      })
      .then((response: any) => {
        if (response.error) {
          throw new Error(response.error);
        }
        this.snackbar = {
          show: true,
          text: "Ruta guardada correctamente",
          color: "success",
        };
      });
  }

  public editandoNombre: boolean = false;
  public planificacion_nombre: string = "Planificación automática";
}
